import Box from '@mui/joy/Box'
import Button from '@mui/joy/Button'
import { SocialNetworkCard } from './SocialNetworkCard'

export const ConnectedNetworks = ({ accounts, onDisconnect }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
            {accounts.map((item) => (
                <SocialNetworkCard
                    key={item}
                    data={item}
                    onClick={onDisconnect}
                />
            ))}
        </Box>
    )
}
